import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import workProgramService from './WorkProgramService';
import { Pager } from '../Pager';
import { FormGroup, Form, Input, Button } from 'reactstrap';
import { FaKey, FaSortAlphaDown, FaSortAlphaUp, FaEdit, FaTrash } from 'react-icons/fa';

export class WorkProgramList extends Component {
	constructor(props) {
		super(props);
		this.state = { entities: [], page: 1, pageSize: 10, maxPages: 5, sortOrder: "start", searchString: "", loading: true };
	}

	componentDidMount() {
		this.populateData();
	}

	handlePageChange = (page) => {
		this.setState({ page: page }, () => this.populateData());
	}

	handleHeaderClick = (event, header) => {
		event.preventDefault();

		let newSortOrder = this.state.sortOrder;

		switch (header) {
			case 'title': {
				newSortOrder = this.state.sortOrder === 'title' ? 'title_desc' : 'title';
				break;
			}
			case 'leader': {
				newSortOrder = this.state.sortOrder === 'leader' ? 'leader_desc' : 'leader';
				break;
			}
			case 'location': {
				newSortOrder = this.state.sortOrder === 'location' ? 'location_desc' : 'location';
				break;
			}
			case 'start': {
				newSortOrder = this.state.sortOrder === 'start' ? 'start_desc' : 'start';
				break;
			}
			case 'end': {
				newSortOrder = this.state.sortOrder === 'end' ? 'end_desc' : 'end';
				break;
			}
		}

		this.setState({ page: 1, sortOrder: newSortOrder }, () => this.populateData());
		return false;
	}

	handleInputChange = (event) => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({ [name]: value });
	}

	handleSearchFormSubmit = (event) => {
		event.preventDefault();
		this.setState({ page: 1 }, () => this.populateData());
		//this.populateData();
	}

	handleSearchFormReset = (event) => {
		event.preventDefault();
		this.setState({ page: 1, searchString: "" }, () => this.populateData());
	}

	renderTable() {
		const { entities, total, sortOrder } = this.state;

		return (
			<div>
				<table className='table table-striped' aria-labelledby="tableLabel">
					<thead>
						<tr>
							<th>
								<a href="#" onClick={(e) => this.handleHeaderClick(e, 'title')} >
									Title&nbsp;
									{sortOrder == 'title' && <FaSortAlphaDown />}
									{sortOrder == 'title_desc' && <FaSortAlphaUp />}
								</a>
							</th>
							<th>
								<a href="#" onClick={(e) => this.handleHeaderClick(e, 'location')} >
									Location&nbsp;
									{sortOrder == 'location' && <FaSortAlphaDown />}
									{sortOrder == 'location_desc' && <FaSortAlphaUp />}
								</a>
							</th>
							<th>
								<a href="#" onClick={(e) => this.handleHeaderClick(e, 'leader')} >
									Leader&nbsp;
									{sortOrder == 'leader' && <FaSortAlphaDown />}
									{sortOrder == 'leader_desc' && <FaSortAlphaUp />}
								</a>
							</th>
							<th>
								<a href="#" onClick={(e) => this.handleHeaderClick(e, 'start')} >
									Date&nbsp;
									{sortOrder == 'start' && <FaSortAlphaDown />}
									{sortOrder == 'start_desc' && <FaSortAlphaUp />}
								</a>
							</th>
							<th />
							<th />
							<th />
						</tr>
					</thead>
					<tbody>
						{entities.map(entity =>
							<tr key={entity.id}>
								<td>{entity.title}</td>
								<td>{entity.location}</td>
								<td>{entity.leader}</td>
								<td>{new Date(entity.start.substring(0, 10)).toLocaleDateString()}</td>
								<td><Link to={'/workprograms/delete/' + entity.id}><FaTrash /></Link></td>
								<td><Link to={'/workprograms/edit/' + entity.id}><FaEdit /></Link></td>
							</tr>
						)}
					</tbody>
				</table>
				<Pager totalItems={total} page={this.state.page} pageSize={this.state.pageSize} maxPages={this.state.maxPages} handlePageChange={this.handlePageChange} />
			</div>
		);
	}

	render() {
		let contents = this.state.loading
			? <p><em>Loading...</em></p>
			: this.renderTable();

		return (
			<div>
				<h1 id="tableLabel">Work Programs</h1>
				<Link to='/workprograms/add/'>Add Work Program</Link>
				<Form inline onSubmit={this.handleSearchFormSubmit}>
					<FormGroup>
						<Input type="text" name="searchString" value={this.state.searchString} onChange={this.handleInputChange} placeholder="Last Name or Email" />
					</FormGroup>&nbsp;
					<Button>Search</Button>&nbsp;
					<Button onClick={this.handleSearchFormReset}>Reset</Button>
				</Form><br />
				{contents}
			</div>
		);
	}

	async populateData() {
		try {

			const data = await workProgramService.getData(this.state.page, this.state.pageSize, this.state.sortOrder, this.state.searchString);
			data.entities.forEach(function (item) {
				var leader = item.leader;
				if (leader) {
					item.leader = leader.firstname + " " + leader.surname;
					item.leaderid = leader.id;
				} else {
					item.leader = "";
                }

			});
			this.setState({ total: data.total, entities: data.entities, loading: false });
		}
		catch (error) {
			// Handle error
		}
	}
}